import { select } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import * as Store from '@core/redux/stores';
import { environment } from '@environments/environment';
import {
  contactMedium,
  FeedbackAdditional,
  FeedbackCategory,
  FeedbackSubCategory,
  FeedbackValues,
  PickUpMethod,
  SourceType,
  SubmitFeedBack,
  TimeOfDay,
  topicType
} from '@features/contact-us/models/contact-us.models';
import moment from 'moment';
import { Observable } from 'rxjs';
import { map } from "rxjs/operators";

const ORDER_PICKUP_TYPE_TO_API: readonly number[] = [
  PickUpMethod['Did Not Visit'],
  PickUpMethod['Dine In'],
  PickUpMethod['Drive Thru'],
  PickUpMethod['Take Out'],
  PickUpMethod.Curbside,
  PickUpMethod.Delivery
];

@Injectable()


export class SubmitFeedbackService {

  @select((appState) => appState.contactUs) contactDetails?: Observable<Store.ContactUs>;
  public thankYouData: any;
  public contactCategories: FeedbackValues;

  private mapToFeedbackServiceType(problemPickUpType: number | null | undefined): number {
    if (problemPickUpType == null) return PickUpMethod.Unknown;
    const maxOrderIndex = ORDER_PICKUP_TYPE_TO_API.length - 1;
    return problemPickUpType >= 0 && problemPickUpType <= maxOrderIndex ? ORDER_PICKUP_TYPE_TO_API[problemPickUpType] : problemPickUpType;
  }

  private convertToFormData(request, file: File) {
    const formData: FormData = new FormData();
    // const fileToSend = new File([file], fileName) ;
    if (file) {
      formData.append('file', file);
    }
    formData.append('data', JSON.stringify(request));
    return formData;
  }

  feedbackSubmit() {

    return this.contactDetails.pipe(map(contactDetails => {
      let request: FormData;

      const problemCategory: FeedbackCategory = contactDetails.problem && contactDetails.problem.problemCategory && contactDetails.problem.problemCategory.id ? {
        id: contactDetails.problem.problemCategory.id,
        name: contactDetails.problem.problemCategory.title
      } : null;

      const problemSubCategory: FeedbackSubCategory = contactDetails.problem && contactDetails.problem.problemSubCategory && contactDetails.problem.problemSubCategory.id ? {
        id: contactDetails.problem.problemSubCategory.id,
        name: contactDetails.problem.problemSubCategory.title
      } : null;


      const problemAdditional: FeedbackAdditional = contactDetails.problem && contactDetails.problem.problemAdditional && contactDetails.problem.problemAdditional ? {
        id: contactDetails.problem.problemAdditional.id,
        name: contactDetails.problem.problemAdditional.title
      } : null;

      let comments = '';
      if (contactDetails.userExperience && contactDetails.userExperience.experience) {
        comments = contactDetails.userExperience.experience;
      }
      if (contactDetails.problem && contactDetails.problem.problemDetails) {
        comments = contactDetails.problem.problemDetails;
      }

      const mentionYes = contactDetails.visitInfo?.mention?.toLowerCase() === 'yes';
      const isOnline = contactDetails.visitInfo?.isOnlineOrder;
      const topic = contactDetails.topicName?.toLowerCase();

      const isItAboutALocation =
        topic === 'problem' ? mentionYes && !isOnline : mentionYes;
      let orderPlacedDate: string | null = null;
      if (contactDetails.visitInfo?.date) {
        orderPlacedDate = moment.utc(contactDetails.visitInfo.date).format('YYYY-MM-DD');
      }

      let feedbackRequest: SubmitFeedBack = {
        problemCategories: contactDetails.userExperience?.problemCategories ?? [],
        isOnlineOrder: contactDetails.visitInfo?.isOnlineOrder || null,
        firstName: contactDetails.contactInformation?.firstName || null,
        lastName: contactDetails.contactInformation?.lastName || null,
        email: contactDetails.contactInformation?.email || null,
        phoneNumber: contactDetails.contactInformation?.phoneNumber || null,
        locationUnitNumber: contactDetails.visitInfo?.restaurantLocation?.unit || null,
        source: SourceType.Web,
        comments: comments,
        topicType: topicType[contactDetails.topicName],
        contactBy: contactDetails.contactInformation?.typeOfContact ? contactMedium[contactDetails.contactInformation.typeOfContact] : null,
        version: environment.CONTACT_US_VERSION,
        visitDate: contactDetails.visitInfo?.date || null,
        posOrderNo: contactDetails?.problem?.problemReceiptNumber?.toString() || null,
        timeOfDay: contactDetails.visitInfo?.time ? TimeOfDay[contactDetails.visitInfo.time] : null,
        serviceType: this.mapToFeedbackServiceType(contactDetails.problem?.problemPickUpType ?? undefined),
        accountEmail: contactDetails.contactInformation?.email || '',
        attachment: '',
        attachmentName: '',
        orderItems: contactDetails.problem && contactDetails.problem.problemItems || [],
        orderId: contactDetails.problem && contactDetails.problem.orderId || '',
        isItAboutALocation: isItAboutALocation || false,
        orderPlacedDate,
        feedbackCategoryInfo: {
          feedbackCategories: [problemCategory || {}],
          feedbackSubCategories: [problemSubCategory || {}],
          additionalFeedbacks: [problemAdditional || {}]
        }
      };
      if (contactDetails.topicName === 'Suggestion' || contactDetails.topicName === 'Compliment') {
        feedbackRequest.serviceType = PickUpMethod.Unknown;
      }

      // TODO: Check if the userexperience object ever has an image and then get rid of the else if block if it does not have it
      let imageFile: File | null = null;
      if (contactDetails.problem?.problemImage?.content && contactDetails.problem.problemImage.content instanceof File) {
        imageFile = contactDetails.problem.problemImage.content;
      } else if (contactDetails.userExperience?.image?.content && contactDetails.userExperience.image.content instanceof File) {
        imageFile = contactDetails.userExperience.image.content;
      }
      
      request = this.convertToFormData(feedbackRequest, imageFile);
      return request;
    }));
  }
}
